import React from 'react'
import styled from 'styled-components'
import LegacyButton from 'components/LegacyButton'

import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { color } from 'styles/colors'

type Props = {
  selectedFilters: string[];
  clearAllFiltersCallback: () => void;
  removeFilterCallback: (selectedFilter) => void;
}

const SelectedFilterList = ({ selectedFilters, clearAllFiltersCallback, removeFilterCallback }: Props) => {
  return (
    <S.SelectedFilters>
      <S.ClearAllFilterButton variant="link" onClick={clearAllFiltersCallback}>Clear All</S.ClearAllFilterButton>
      {selectedFilters.map(filter => (
        <S.ClearSelectedFilterButton key={filter} variant="link">
          <S.ButtonText>
            {filter}
            <HighlightOffIcon data-testid={filter} onClick={() => { removeFilterCallback(filter) }} />
          </S.ButtonText>
        </S.ClearSelectedFilterButton>
      ))}
    </S.SelectedFilters>
  )
}

export default SelectedFilterList

const S = {
  SelectedFilters: styled.div`
    display: flex;
    margin: 10px 10px 10px 0px;
    gap: 10px;
  `,
  ClearAllFilterButton: styled(LegacyButton)`
    display: block;
    background-color: ${color('tooltipBorder')};
    border: 1px solid ${color('tooltipBorder')};
    border-radius: 10px;
    padding: 2px 8px 0px 8px;
    font-size: 13px;
    color: ${color('customerFilterButtonText')};
  `,
  ClearSelectedFilterButton: styled(LegacyButton)`
    display: block;
    border: 1px solid ${color('tooltipBorder')};
    border-radius: 10px;
    padding: 2px;
    font-size: 12px;
  `,
  ButtonText: styled.div`
    display: flex;
    color: ${color('tooltipBorder')};
    align-items: center;
    padding-left: 5px;
    gap: 5px;
  `
}
